import { API_CALL } from './actionConstants'
import { FETCH_RELATED_TRAVEL_DESTINATIONS } from './apiActionConstants'
import { urlTransform } from 'lib/string/removeSpaceUtils'
import { OFFER_TYPE_HOTEL_SLUG } from 'constants/offer'
import { getPlaceBySlug } from 'api/search'
import { AppAction } from './ActionTypes'
import { nonNullable } from 'lib/array/arrayUtils'

async function createSimpleBreadCrumb(locations: Array<string>): Promise<Array<App.BreadcrumbItem>> {
  const locationPathDeduplicated = locations.filter((location, index) => !locations.slice(0, index).includes(location))
  const locationPaths = locationPathDeduplicated.map((location, index) => [location, ...locationPathDeduplicated.slice(0, index).reverse()])
  return nonNullable((await Promise.all(locationPaths.map(async(paths): Promise<App.BreadcrumbItem | null> => {
    const realPathSuggestion = await getPlaceBySlug(paths.join(', '))
    const realPath = realPathSuggestion.canonicalName
    if (!realPath) {
      return null
    }
    const parseRealPath = (realPath:string) => {
      const splittedRealPath = realPath.split(', ')
      return (splittedRealPath.length === 1 ? 'country' : 'location') + '/' + splittedRealPath.join('/')
    }
    return {
      text: paths[0],
      url: `/hotels/${urlTransform(parseRealPath(realPath).toLowerCase())}`,
    }
  }))))
}

async function getRelatedTravelItemsForDestinationPage(location: string): Promise<Array<App.BreadcrumbItem>> {
  if (!location) {
    return []
  }
  const locations = location.split(', ').reverse()
  const locationsDeduplicated = locations.filter((location, index) => !locations.slice(0, index).includes(location))
  const firstBreadcrumb: Array<App.BreadcrumbItem> = [{ text: 'Hotels', url: `/${OFFER_TYPE_HOTEL_SLUG}` }]
  const allBreadcrumb = await createSimpleBreadCrumb(locations)
  const breadcrumbs: Array<App.BreadcrumbItem> = firstBreadcrumb.concat(allBreadcrumb)
  if (breadcrumbs.slice(-1)[0].text !== locationsDeduplicated.slice(-1)[0]) {
    breadcrumbs.push({ text: locations.slice(-1)[0] })
  } else {
    breadcrumbs[breadcrumbs.length - 1] = { text: locationsDeduplicated.slice(-1)[0] }
  }
  return breadcrumbs
}

export function fetchRelatedTravelDestinations(location: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.destinationProductPage.relatedTravelDestinations[location] !== undefined) {
      // already calculated, nothing to do so return early.
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_RELATED_TRAVEL_DESTINATIONS,
      request: () => getRelatedTravelItemsForDestinationPage(location),
      location,
    })
  }
}
